import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Popover } from 'element-ui';
import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import Header from '@/components/shared/answer-types/header/header.vue';

export default {
    name: 'RaceOfficer',
    props: {
        id: [Number, String],

    },
    components: {
        [Popover.name]: Popover,
        'text-answer': TextAnswer,
        'header-answer': Header
    },
    computed: {
        isSaveAvailable() {
            return this.users &&
                this.users.filter(user => {
                    return (!user.errorMessagesTiId || !user.errorMessagesTiId.length) &&
                        (!user.errorMessagesName || !user.errorMessagesName.length) &&
                        (!user.errorMessagesEmail || !user.errorMessagesEmail.length) &&
                        (!user.errorMessagesPhone || !user.errorMessagesPhone.length)
                }).length == this.users.length;
        }
    },
    data() {
        return {
            isProcessing: false,
            newUserTiIdOrEmail: null,
            users: []
        };
    },
    methods: {
        showWarning(message) {
            if (!message) {
                message = 'Warning!';
            }
            this.$notify({
                message: message,
                type: 'warning',
                timeout: 5000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        init() {
            this.load();
        },
        cancel() {
            this.load();
        },
        setFieldEventUpdate(user, id, propertyIdName, propertyToUpdateName, additionalAction) {
            user[propertyIdName] = id;

            EventBus.$off(`update-value-field-id-${id}`)
            EventBus.$on(`update-value-field-id-${id}`, value => {
                user[propertyToUpdateName] = value;
                if (additionalAction) {
                    additionalAction(user);
                }
            });

        },
        setFieldEventClear(user, id, propertyToUpdateName, additionalAction) {
            EventBus.$off(`clear-value-field-id-${id}`)
            EventBus.$on(`clear-value-field-id-${id}`, () => {
                if (propertyToUpdateName) {
                    user[propertyToUpdateName] = null;
                }
                if (additionalAction) {
                    additionalAction(user);
                }
            });
        },
        updateUserName(user) {
            if (user && user.firstName && user.lastName) {
                user.name = user.firstName + ' ' + user.lastName;
            }
        },
        clearAllUserFields(user) {
            if (user) {
                user.firstName = null;
                user.lastName = null;
                user.name = null;
            }
        },
        updateMap() {
            var self = this;
            if (self.users && self.users.length) {
                self.users.forEach((user, index) => {
                    user.index = index * 10;
                    self.setFieldEventUpdate(user, index * 10 + 1, "firstNameId", "firstName", self.updateUserName);
                    self.setFieldEventUpdate(user, index * 10 + 2, "lastNameId", "lastName", self.updateUserName);
                    //3 it's name
                    self.setFieldEventUpdate(user, index * 10 + 4, "emailId", "email");
                    self.setFieldEventUpdate(user, index * 10 + 5, "phoneId", "phone");

                    self.setFieldEventClear(user, user.index, "tiIdNumber");
                    self.setFieldEventClear(user, index * 10 + 1, "", self.clearAllUserFields);
                    self.setFieldEventClear(user, index * 10 + 2, "", self.clearAllUserFields);
                    self.setFieldEventClear(user, index * 10 + 4, "phone");
                    self.setFieldEventClear(user, index * 10 + 5, "email");
                });
            }
        },
        load() {
            var self = this;
            self.isProcessing = true;
            request.getRaceOfficers(self.id)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        if (response.body.outputData && response.body.outputData.length) {
                            self.users = response.body.outputData;
                            self.updateMap();
                        }
                        else {
                            self.users = [];
                        }
                    } else {
                        self.$showError();
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },
        save() {
            self = this;
            self.isProcessing = true;
            request.setRaceOfficers(self.id, self.users)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.$showSuccess();
                    } else {
                        if (response && response.body && response.body.message) {
                            self.$showError(response.body.message);
                        }
                        else {
                            self.$showError();
                        }
                    }
                    self.cancel();
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },
        add() {
            self = this;
            if (!self.newUserTiIdOrEmail) {
                self.$showError("Please enter email or TI number")
                return;
            }
            self.isProcessing = true;

            request.getMemberByLoginOrTiID(self.newUserTiIdOrEmail)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body &&
                        response.body.isSuccess &&
                        response.body.outputData &&
                        response.body.outputData["TI Number"]) {

                        var model = {};
                        model["id"] = response.body.outputData["Id"];
                        model["email"] = response.body.outputData["Email"];
                        model["firstName"] = response.body.outputData["First Name"];
                        model["lastName"] = response.body.outputData["Last Name"];
                        model["phone"] = response.body.outputData["Phone"];
                        model["tiIdNumber"] = response.body.outputData["TI Number"];

                        var isAlready = self.users.filter(u => u.tiIdNumber == model.tiIdNumber)
                        if (isAlready.length) {
                            self.$showError("This user is already on the list of race admins and can't be add twices");
                        } else {
                            self.users.push(model);
                            self.newUserTiIdOrEmail = null;
                        }
                    } else {
                        self.$showError("User is not found. Check query and try again");
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        }
    },
    mounted() {
        this.init();
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-officer/race-officer.js